import * as React from 'react';
import { WatchedShipment } from 'services/clients/watchList';

import {
  ArchiveBoxIcon,
  EyeIcon,
  NoSymbolIcon,
  SignalIcon,
  TrashIcon,
} from '@heroicons/react/24/solid';
import { CellProps } from './types';
import { Cell } from './Cell';

export const TrackStatusCell: React.FC<CellProps> = (props) => {
  const watch: WatchedShipment = props.row;

  const defaultStyles = 'flex items-center justify-center space-x-1';

  switch (watch.trackingStatus) {
    case 'TRACKING':
      return (
        <Cell className={`text-green-900 ${defaultStyles}`}>
          <EyeIcon style={{ width: 16 }} />
          <h4>Tracking</h4>
        </Cell>
      );
    case 'LOCATING':
      return (
        <Cell className={`text-darkorange-900 ${defaultStyles}`}>
          <SignalIcon style={{ width: 16 }} />
          <h4 className="text-darkorange-900">Locating</h4>
        </Cell>
      );
    case 'UNABLE_TO_LOCATE':
      return (
        <Cell className={`text-red-900 ${defaultStyles}`}>
          <NoSymbolIcon style={{ width: 16 }} />
          <h4>Unable to locate</h4>
        </Cell>
      );
    case 'ARCHIVED':
      return (
        <Cell className={`text-gray-900 ${defaultStyles}`}>
          <ArchiveBoxIcon style={{ width: 16 }} />
          <h4>Inactive</h4>
        </Cell>
      );
    case 'DELETED':
      return (
        <Cell className={`text-gray-500 ${defaultStyles}`}>
          <TrashIcon style={{ width: 16 }} />
          <h4>Deleted</h4>
        </Cell>
      );
    default:
      break;
  }

  return null;
};
TrackStatusCell.displayName = 'AddContainers.RecentlyAdded.Table.TrackStatusCell';
